<template>
  <Form :method="method" :action="action" :form-data="form" @success="success">
    <template v-slot="{ errors, submitting }">
      <h3 class="text-gray-400 mb-4">Deal {{ contact ? 'bij ' + contact.name : '' }}</h3>
      <div class="sm:bg-gray-100 rounded py-3 sm:px-3 mb-4">
        <div class="flex flex-col sm:flex-row -mx-2">
          <BaseRadio
            name="result"
            v-model="form.result"
            value="pending"
            label="Pre-Deal"
            class="mx-2"
          />
          <BaseRadio name="result" v-model="form.result" value="won" label="Gewonnen" class="mx-2" />
          <BaseRadio
            name="result"
            v-model="form.result"
            value="lost"
            label="Verloren"
            class="mx-2"
          />
        </div>
      </div>
      <label v-if="isPending && phases.length" class="block mb-4">
        <span class="block mb-1">Welke fase van de pijplijn?</span>
        <BaseSelect name="phase_id" v-model="form.phase_id" :options="$store.getters.phaseOptions" />
      </label>
      <label class="block mb-4" v-if="selectContact">
        <span class="block mb-1">Bij welk bedrijf hoort deze deal?</span>
        <ContactPicker
          name="contact_id"
          v-model="form.contact_id"
          :error="errors.contact_id"
          @picked="picked"
          required
          v-focus
        />
      </label>
      <label class="block mb-4">
        <span class="block mb-1">Omschrijving (max. 80 tekens)</span>
        <BaseInput
          name="description"
          v-model="form.description"
          :error="errors.description"
          placeholder="Korte omschrijving van de deal"
          required
          v-focus="!selectContact"
          ref="description"
        />
      </label>
      <div class="sm:flex -mx-1">
        <label class="sm:w-1/3 block mx-1 mb-4">
          <span class="block mb-1">Bedrag</span>
          <BaseInput name="amount" type="number" v-model="form.amount" :error="errors.amount" />
        </label>
        <label class="sm:w-1/3 block mx-1 mb-4" v-if="!isPending">
          <span class="block mb-1">{{ isLost ? 'Verloren' : 'Gewonnen' }} op</span>
          <DatePicker
            name="closed_at"
            id="closed_at"
            v-model="form.closed_at"
            :error="errors.closed_at"
            placeholder="dd-mm-jjjj"
            required
          />
        </label>
        <label class="sm:w-1/3 block mx-1 mb-4" v-if="!isPending">
          <span class="block mb-1">Door</span>
          <BaseSelect name="user_id" v-model="form.user_id" :options="$store.getters.userOptions" />
        </label>
      </div>
      <div class="flex py-3 mt-5">
        <button type="submit" class="btn btn-blue" :disabled="submitting">Opslaan</button>
        <button type="button" class="cancel" @click="close">Annuleren</button>
      </div>
    </template>
  </Form>
</template>

<script>
import auth from "@/auth.js";
import { focusFirstFormElement } from "@/functions.js";
import Form from "@/components/Form";
import ContactPicker from "@/components/ContactPicker";
import DatePicker from "@/components/DayPicker";

export default {
  inject: ["close"],

  props: {
    method: {
      type: String,
      default: "post"
    },
    action: {
      type: String,
      required: true
    },
    deal: {
      type: Object
    },
    contact: {
      type: Object
    },
    result: {
      type: String,
      default: "pending"
    }
  },

  components: {
    Form,
    ContactPicker,
    DatePicker
  },

  data() {
    return {
      form: {
        result: this.result,
        phase_id: this.$store.state.settings.phases
          ? this.$store.state.settings.phases[0].id
          : null,
        description: "",
        amount: "",
        closed_at: "",
        user_id: auth.user.id,
        contact_id: ""
      }
    };
  },

  computed: {
    phases() {
      return this.$store.state.settings.phases || [];
    },
    selectContact() {
      return !this.contact;
    },
    isPending() {
      return this.form.result === "pending";
    },
    isLost() {
      return this.form.result === "lost";
    },
    isDone() {
      return this.form.result !== "pending";
    }
  },

  created() {
    if (this.deal) {
      this.form.result = this.deal.result ? this.deal.result : "pending";
      this.form.phase_id = this.deal.phase_id;
      this.form.description = this.deal.description;
      this.form.amount = this.deal.amount;
      this.form.closed_at = this.deal.closed_at;
      this.form.user_id = this.deal.user_id;
    }
  },

  methods: {
    success(data) {
      this.$emit("success", data);
      this.close();
    },

    picked(contact_id) {
      if (contact_id) {
        focusFirstFormElement(this.$refs.description);
      }
    }
  }
};
</script>
